import { render, staticRenderFns } from "./StartDialog.vue?vue&type=template&id=0c176335&scoped=true"
import script from "./StartDialog.vue?vue&type=script&lang=js"
export * from "./StartDialog.vue?vue&type=script&lang=js"
import style0 from "./StartDialog.vue?vue&type=style&index=0&id=0c176335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c176335",
  null
  
)

export default component.exports